import { registerEnum } from '@cbbt/lib-interface';
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["COMMON_LAW"] = "COMMON_LAW";
    MaritalStatus["DIVORCED"] = "DIVORCED";
    MaritalStatus["DIVORCED_SEPARATED"] = "DIVORCED_SEPARATED";
    MaritalStatus["ENGAGED"] = "ENGAGED";
    MaritalStatus["LEGALLY_SEPARATED"] = "LEGALLY_SEPARATED";
    MaritalStatus["MARRIED_CIVIL_PARTNER"] = "MARRIED_CIVIL_PARTNER";
    MaritalStatus["NO_RESPONSE"] = "NO_RESPONSE";
    MaritalStatus["OTHER"] = "OTHER";
    MaritalStatus["OTHER_FROM_CBS"] = "OTHER_FROM_CBS";
    MaritalStatus["SEPARATED"] = "SEPARATED";
    MaritalStatus["SINGLE"] = "SINGLE";
    MaritalStatus["UNKNOWN"] = "UNKNOWN";
    MaritalStatus["WIDOWED"] = "WIDOWED";
})(MaritalStatus || (MaritalStatus = {}));
registerEnum(MaritalStatus, 'MaritalStatus');
export { MaritalStatus };
//# sourceMappingURL=MartialStatus.js.map